// extracted by mini-css-extract-plugin
export default {"mainSingleContainerWrapper":"CollaboratorsShow_mainSingleContainerWrapper__cnBkZ"};